<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const FeatureBuyInTabIcon = getIcon("FeatureBuyInTabIcon");
export let size = 17;
export let active = false;
export let hover = false;
export let color = undefined;
</script>

{#if typeof FeatureBuyInTabIcon === 'string'}
	<img src={FeatureBuyInTabIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof FeatureBuyInTabIcon === 'function'}
	<svelte:component this={FeatureBuyInTabIcon} {size} {active} {hover} {color} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
